import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"hero"}},[_c(VRow,{attrs:{"no-gutters":""}},[_c(VImg,{attrs:{"height":'calc(100vh - ' + _vm.$vuetify.application.top + 'px)',"max-height":"500","src":require('../assets/traverse-board.jpg'),"gradient":"to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }